import { Avatar, AvatarProps, BadgeProps, badgeClasses } from '@mui/material';
import clsx from 'clsx';
import OutlinedBadge from 'components/styled/OutlinedBadge';
import { getInitials } from 'lib/utils';

interface StatusAvatarProps extends AvatarProps {
  status: 'online' | 'offline';
}

const StatusAvatar = ({ status, alt, src, sx, ...rest }: StatusAvatarProps) => {
  const initials = alt ? getInitials(alt) : '';

  return (
    <OutlinedBadge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      variant="dot"
      color={
        clsx({
          success: status === 'online',
          error: status === 'offline',
        }) as BadgeProps['color']
      }
      sx={{
        [`& .${badgeClasses.badge}`]: {
          height: 10,
          width: 10,
          borderRadius: '50%',
        },
      }}
    >
      <Avatar src={src || undefined} alt={alt} sx={sx} {...rest}>
        {!src && initials}
      </Avatar>
    </OutlinedBadge>
  );
};

export default StatusAvatar;
